export default __webpack_public_path__ + "static/media/Copy of The Kruks Photography-946_tn.0fbc2994.jpg";